"use strict";
import { TransactionType } from "features/transactions/types/transactionDetails";
import { buildCurrencyId, buildNativeCurrencyId, buildWrappedNativeCurrencyId } from "utils/uniswapCurrencyId";
import { logger } from "utilities/src/logger/logger";
export function getCurrenciesWithExpectedUpdates(transaction) {
  const currenciesWithBalToUpdate = /* @__PURE__ */ new Set();
  const txChainId = transaction.chainId;
  currenciesWithBalToUpdate.add(buildNativeCurrencyId(txChainId));
  switch (transaction.typeInfo?.type) {
    case TransactionType.Swap:
    case TransactionType.Bridge:
      currenciesWithBalToUpdate.add(transaction.typeInfo.inputCurrencyId.toLowerCase());
      currenciesWithBalToUpdate.add(transaction.typeInfo.outputCurrencyId.toLowerCase());
      break;
    case TransactionType.Send:
      currenciesWithBalToUpdate.add(buildCurrencyId(txChainId, transaction.typeInfo.tokenAddress).toLowerCase());
      break;
    case TransactionType.Wrap:
      currenciesWithBalToUpdate.add(buildWrappedNativeCurrencyId(txChainId));
      break;
    case TransactionType.OnRampPurchase:
    case TransactionType.OnRampTransfer:
    case TransactionType.OffRampSale:
      currenciesWithBalToUpdate.add(
        buildCurrencyId(txChainId, transaction.typeInfo.destinationTokenAddress).toLowerCase()
      );
      break;
    default:
      logger.info(
        "getCurrenciesWithExpectedUpdates.ts",
        "getCurrenciesWithExpectedUpdates",
        "Unhandled transaction type",
        {
          type: transaction.typeInfo?.type,
          info: JSON.stringify(transaction.typeInfo)
        }
      );
      break;
  }
  return currenciesWithBalToUpdate;
}
